<template>
  <div class="register-wrap">
    <authLeft v-if="$mq != 'sp' && $mq != 'tb'" />
    <div class="register-right">
      <div class="register-form" v-if="mode == 'verifyEmail'">
        <div class="register-form-title">メールアドレスの認証完了</div>
        <img class="register-form-img" src="../../assets/authentication.png" alt />
        <div>
          <div>メールアドレスの認証が完了しました。</div>
          <router-link to="/login">
            <el-button style="width:100%; margin-top:30px;" type="primary">ログイン画面へ</el-button>
          </router-link>
        </div>
      </div>
      <div class="register-form" v-if="mode == 'resetPassword'">
        <div class="register-form-title">パスワード再設定</div>
        <div class="register-form-session" v-if="error.password">
          パスワードリセットの有効期限が切れています。
          <br />再度パスワードリセットをやり直してください。
        </div>
        <el-form :model="form" :rules="rules" ref="form" v-if="!error.password" @submit.native.prevent="resetPassword2">
          <div class="register-form-subtitle">新しいパスワード</div>
          <el-form-item prop="pass">
            <el-input placeholder="パスワード" v-model="form.pass" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">新しいパスワード(再入力)</div>
          <el-form-item prop="checkPass">
            <el-input placeholder="パスワード(再入力)" v-model="form.checkPass" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-button style="width:100%; margin-top:30px;" type="primary" native-type="submit" :disabled="loading">
            <div class="flex-row">
              パスワード変更
              <div class="loader--mini" v-show="loading"></div>
            </div>
          </el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import authLeft from "./auth_left";
const root = process.env.VUE_APP_API;
const logoutAPI = root + "/api/auth/logout";
const changePasswordAPI = root + "/api/auth/change_password";

export default {
  name: "register",
  components: {
    authLeft,
  },
  data() {
    // var validateEmail = (rule, value, callback) => {
    //   var freeCheck = value.match(freeEmail);
    //   if (!value) {
    //     return callback(new Error("Please input the age"));
    //   }
    //   if (freeCheck) {
    //     callback(new Error("フリーアドレスはご利用いただけません"));
    //   } else {
    //     callback();
    //   }
    // };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードは必須です"));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワード(再入力)は必須です"));
      } else if (value !== this.form.pass) {
        callback(new Error("パスワードが一致しません"));
      } else {
        callback();
      }
    };
    return {
      mode: "",
      actionCode: "",
      continueUrl: "",
      lang: "",
      loading: false,
      email: "",
      form: {
        email: "",
        pass: "",
        checkPass: "",
      },
      error: {
        password: false,
      },
      token: "",
      rules: {
        pass: [
          { required: true, message: "パスワードは必須です", trigger: "blur" },
          {
            min: 8,
            message: "パスワードは8文字以上で設定してください",
            trigger: "blur",
          },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.loadQuery();
    if (this.mode == "resetPassword") {
      this.resetPassword1();
    } else if (this.mode == "verifyEmail") {
      this.verifyEmail();
    }
    this.currentUser();
  },
  methods: {
    loadQuery() {
      this.mode = this.$route.query.mode;
      this.actionCode = this.$route.query.oobCode;
      this.continueUrl = this.$route.query.continueUrl;
      this.lang = this.$route.query.lang;
    },
    currentUser() {
      firebase
        .auth()
        .onAuthStateChanged()
        .then((user) => {
          this.token = user.uid;
        })
        .catch(() => {});
    },
    resetPassword1() {
      firebase
        .auth()
        .verifyPasswordResetCode(this.actionCode)
        .then((email) => {
          this.email = email;
        })
        .catch(() => {
          this.error.password = true;
        });
    },
    resetPassword2() {
      this.loading = true;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          firebase
            .auth()
            .confirmPasswordReset(this.actionCode, this.form.pass)
            .then(() => {
              this.redirect();
            })
            .catch(() => {
              this.$message.error("パスワードが脆弱すぎるかパスワードリセットの有効期限が切れています");
              this.loading = false;
            });
        } else {
          this.$message.error("パスワードが一致していないか8文字未満です");
          this.loading = false;
        }
      });
    },
    verifyEmail() {
      firebase
          .auth()
          .applyActionCode(this.actionCode)
          .then(() => {
            this.$router.push("/dashboard");
          })
          .catch(() => {
            this.$message.error("パスワードの変更に失敗しました。パスワードリセットの有効期限が切れています。");
          });
    },
    redirect() {
      this.$store.dispatch("resetToken");
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.form.pass)
        .then((authData) => {
          var params = new URLSearchParams();
          params.append("pass", this.form.pass);
          params.append("uid", authData.user.uid);
          this.axios.post(changePasswordAPI, params)
            .then((response) => {
              this.axios
                .get(logoutAPI, {
                  params: {
                    token: authData.user.uid,
                    user_token: response.data.user_token
                  },
                })
                .then(() => {
                  this.$store.dispatch("getUserData", { token: response.data.token, user_token: response.data.user_token });
                  this.$message({
                    type: "success",
                    duration: 0,
                    message: "パスワードを変更しました。5秒後に自動ログインします。",
                  });
                  setTimeout(() => {
                    this.$router.push("/dashboard");
                    this.$message.closeAll();
                    this.loading = false;
                  }, 5000);
                });
            })
            .catch(() => {
              this.loading = false;
              this.$message.error("パスワードの変更に失敗しました。");
            });
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("パスワードの変更に失敗しました。パスワードリセットの有効期限が切れています。");
        });
    },
  },
};
</script>
